// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.4.0",
  date: "2026-07-29T11:05:06.842Z",
  gitInfo: {
    dirty: false,
    raw: "a56d2ea30",
    hash: "a56d2ea30",
    distance: null,
    tag: null,
    semver: null,
    suffix: "a56d2ea30",
    semverString: null
  }
};
/* tslint:enable */
